import React from 'react';

/**
 * ElementsPanel component for GuiBuilder
 * Panel for inserting page elements (headers, text, exit button)
 */
export default function ElementsPanel({
    pages,
    addHeader,
    addDescription,
    addExitButton
}) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <button
                type="button"
                onClick={addHeader}
                className="item-highlight"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    width: '100%',
                    padding: '0.6rem 1rem',
                    fontSize: '0.85rem'
                }}
            >
                <i className="fa-solid fa-heading"></i> Add Section Header
            </button>

            <button
                type="button"
                onClick={addDescription}
                className="item-highlight"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    width: '100%',
                    padding: '0.6rem 1rem',
                    fontSize: '0.85rem'
                }}
            >
                <i className="fa-solid fa-align-left"></i> Add Context Paragraph
            </button>

            <button
                type="button"
                onClick={addExitButton}
                className="item-highlight"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    width: '100%',
                    padding: '0.6rem 1rem',
                    fontSize: '0.85rem'
                }}
                disabled={pages.some(p => p.elements.some(el => el.type === 'exit-button'))}
            >
                <i className="fa-solid fa-arrow-right-from-bracket"></i> Add Exit Button
            </button>
        </div>
    );
}
